export const ROOT = '/sms';
export const MODULE = 'SMS';